module.exports = __webpack_public_path__ + "media/eye.235f1cf1.wav";